import React from 'react';
import { useAuth } from 'shared-auth';

const TEEZNET_URL = process.env.REACT_APP_TEEZNET_URL;

const AuthWidget: React.FC = () => {
    const { isAuthenticated, user, logout, isLoading, openAuthModal } = useAuth();

    if (isLoading) {
        return <div className="text-sm text-slate-500 w-24 h-6 animate-pulse bg-slate-200/20 dark:bg-slate-700/50 rounded-md"></div>;
    }

    if (isAuthenticated && user) {
        return (
            <div className="flex items-center gap-4 text-sm text-slate-200 [text-shadow:0_1px_2px_rgba(0,0,0,0.5)]">
                <span className="font-medium hidden sm:inline" title={user.email}>
                    Hi, {user.name.split(' ')[0]}
                </span>
                <a
                    href={`${TEEZNET_URL}/account`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold hover:text-white transition-colors"
                >
                    Dashboard
                </a>
                <button
                    onClick={logout}
                    className="font-semibold hover:text-white transition-colors"
                >
                    Logout
                </button>
            </div>
        );
    }

    return (
        <div className="flex items-center gap-4 text-sm font-semibold">
            <button onClick={() => openAuthModal('login')} className="text-slate-200 hover:text-white transition-colors [text-shadow:0_1px_2px_rgba(0,0,0,0.5)]">
                Login
            </button>
            <button onClick={() => openAuthModal('register')} className="px-3 py-1.5 bg-cyan-500 text-white rounded-full hover:bg-cyan-600 transition-colors shadow-sm">
                Register
            </button>
        </div>
    );
};

export default AuthWidget;